export default __webpack_public_path__ + "static/media/PRODUCT_BNR_2020-03-04T11_36_46.cdb46a5d.png";